import { render, staticRenderFns } from "./ResearchCitation.vue?vue&type=template&id=f61ea3ec&scoped=true"
import script from "./ResearchCitation.vue?vue&type=script&lang=js"
export * from "./ResearchCitation.vue?vue&type=script&lang=js"
import style0 from "./ResearchCitation.vue?vue&type=style&index=0&id=f61ea3ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61ea3ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f61ea3ec')) {
      api.createRecord('f61ea3ec', component.options)
    } else {
      api.reload('f61ea3ec', component.options)
    }
    module.hot.accept("./ResearchCitation.vue?vue&type=template&id=f61ea3ec&scoped=true", function () {
      api.rerender('f61ea3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchCitation.vue"
export default component.exports